import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { TRABADJU_INFO as T } from '@/utils/businessInfo';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function Cookies() {
  const { t } = useTranslation();
  const today = new Date().toLocaleDateString('pt-PT');
  return (
    <div className="min-h-screen bg-gray-50 py-10" data-testid="page-cookies">
      <div className="max-w-3xl mx-auto px-4">
        <Link to="/"><Button variant="ghost" className="mb-4"><ArrowLeft className="h-4 w-4 mr-2" />{t('legal.back')}</Button></Link>
        <article className="bg-white rounded-xl shadow-sm p-8 prose prose-slate max-w-none">
          <h1 className="text-3xl font-bold mb-2">{t('legal.cookiesTitle')}</h1>
          <p className="text-sm text-gray-500 mb-2">{t('legal.lastUpdated', { date: today })}</p>
          <p className="text-xs text-gray-400 mb-6 not-italic">{t('legal.ptOnlyNotice')}</p>

          <h2>1. O que são cookies?</h2>
          <p>Cookies são pequenos ficheiros de texto que um site coloca no dispositivo do utilizador para guardar informação entre visitas. O <strong>{T.brand}</strong> utiliza tecnologias semelhantes (cookies, <em>localStorage</em>, <em>sessionStorage</em>) para garantir o funcionamento correcto da plataforma.</p>

          <h2>2. Tipos de cookies/armazenamento que utilizamos</h2>

          <h3>2.1 Estritamente necessários (sempre activos)</h3>
          <ul>
            <li><strong>access_token / refresh_token</strong> (localStorage) — autenticação JWT do utilizador.</li>
            <li><strong>user</strong> (localStorage) — perfil do utilizador para o frontend.</li>
            <li><strong>i18nextLng</strong> (localStorage) — idioma seleccionado.</li>
          </ul>

          <h3>2.2 Funcionais</h3>
          <ul>
            <li>Preferências de filtros e pesquisa (categoria, localização) — guardadas apenas durante a sessão.</li>
          </ul>

          <h3>2.3 Terceiros</h3>
          <ul>
            <li><strong>SISP / vinti4</strong> — durante o processo de pagamento com cartão, o portal da SISP pode definir cookies próprios. Consulte a política da SISP em sisp.cv.</li>
            <li><strong>Cloudflare</strong> — cookies de segurança e prevenção de bots (cf_clearance, __cf_bm).</li>
          </ul>

          <h2>3. Não utilizamos</h2>
          <p>O Trabadju <strong>não utiliza</strong> cookies de marketing, publicidade ou tracking de terceiros (Google Analytics, Facebook Pixel, etc.).</p>

          <h2>4. Gestão de cookies</h2>
          <p>O utilizador pode gerir ou eliminar cookies/dados do site através das definições do browser:</p>
          <ul>
            <li><strong>Chrome:</strong> Definições → Privacidade e segurança → Cookies</li>
            <li><strong>Firefox:</strong> Preferências → Privacidade e Segurança</li>
            <li><strong>Safari:</strong> Preferências → Privacidade</li>
            <li><strong>Edge:</strong> Definições → Cookies e permissões do site</li>
          </ul>
          <p>Atenção: ao bloquear cookies estritamente necessários, o login e funcionalidades-chave deixam de funcionar.</p>

          <h2>5. Contacto</h2>
          <p>Dúvidas sobre cookies: <a href={`mailto:${T.email_legal}`}>{T.email_legal}</a></p>
        </article>
      </div>
    </div>
  );
}
